module.exports = __webpack_public_path__ + "img/shipo-icon-attachment.f62b40c8.svg";